import { useEffect } from "react";
import CountryBar from "@/jurisdictions/CountryBar";
import { toast } from "sonner";
import { Outlet, useNavigate } from "react-router-dom";
import Onboarding from "@/pages/Onboarding";
import ForcePassword from "@/pages/ForcePassword";
import { useAuth } from "@/context/AuthContext";

export default function Layout() {
  const { user, cabinet, logout } = useAuth();
  const navigate = useNavigate();

  // Déconnexion automatique après inactivité (configurable par cabinet)
  useEffect(() => {
    const mins = Number(cabinet?.session_timeout_minutes || 0);
    if (!Number.isFinite(mins) || mins <= 0) return;
    let timer;
    const reset = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        toast.info("Session expirée par inactivité. Veuillez vous reconnecter.");
        logout();
        navigate("/login");
      }, mins * 60000);
    };
    const evts = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    evts.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();
    return () => { clearTimeout(timer); evts.forEach((e) => window.removeEventListener(e, reset)); };
  }, [cabinet?.session_timeout_minutes, logout, navigate]);


  if (user?.must_change_password) return <ForcePassword />;
  if (["ceo", "associe", "partner"].includes(user?.role) && cabinet && !cabinet.onboarded) return <Onboarding />;

  return <div className="h-[100dvh] flex flex-col overflow-hidden"><CountryBar /><div className="flex-1 min-h-0">
    <Outlet />
  </div></div>;
}
